// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The header is the shared FeatureHeader component. Contrast: white on olive 7.24, cream on olive
   5.76, olive on the page 6.28, olive on sunken 5.39. All AA. */
.busy-bees {
  --bb-olive: var(--color-olive);
  --bb-olive-text: var(--color-white);
  --bb-olive-muted: var(--color-cream);
  --bb-panel: #e9eed6; /* sunken green lifted toward the page, for the supplies panel */
  --bb-beige: #f3e9df;
}

.busy-bees h1,
.busy-bees h2,
.busy-bees h3 {
  color: var(--bb-olive);
}

.busy-bees section {
  padding: 28px 0;
}

/* Content sits in one centered column, as in the design. */
.bb-narrow {
  max-width: 760px;
}

.bb-section-heading {
  text-align: center;
  margin-bottom: 24px;
}

.bb-section-heading h2 {
  margin-bottom: 6px;
}

.bb-section-heading p {
  margin: 0;
  font-size: 0.95rem;
}

/* --- We supply everything ------------------------------------------------ */
/* A centered, roughly square panel rather than a full-width band. */
/* A centered, roughly square panel rather than a full-width band. */
.bb-supplies {
  max-width: 600px;
  margin: 0 auto;
  background-color: var(--bb-panel);
  border-radius: 32px;
  padding: 44px 40px;
}

.bb-supplies .bb-section-heading {
  margin-bottom: 36px;
}

.bb-supplies .bb-section-heading h2 {
  font-size: 2rem;
  margin-bottom: 10px;
}

.bb-supply-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 32px;
}

.bb-supply-row {
  display: flex;
  align-items: center;
  gap: 20px;
}

/* Every other row mirrors: icon on the right, text right-aligned. */
.bb-supply-row:nth-child(even) {
  flex-direction: row-reverse;
  text-align: right;
}

.bb-supply-row h3 {
  font-size: 1.2rem;
  margin: 0 0 6px;
}

.bb-supply-row p {
  margin: 0;
}

.bb-icon-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: var(--surface-raised);
  color: var(--text-accent);
  box-shadow: 0 2px 6px rgba(89, 88, 96, 0.14);
}

/* --- What you'll make ---------------------------------------------------- */
.bb-chips {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}

.bb-chip {
  font-size: 0.9rem;
  font-weight: 600;
  padding: 6px 16px;
  border-radius: 999px;
  border: 1px solid var(--border-subtle);
}

.bb-chip-green {
  background-color: var(--bb-panel);
}

.bb-chip-white {
  background-color: var(--surface-raised);
}

.bb-chip-beige {
  background-color: var(--bb-beige);
}

/* --- How it works -------------------------------------------------------- */
.bb-steps {
  list-style: none;
  margin: 0 auto;
  padding: 0;
  max-width: 480px;
  display: grid;
  gap: 20px;
}

.bb-steps li {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.bb-steps h3 {
  font-size: 1.05rem;
  margin: 0 0 2px;
}

.bb-steps p {
  margin: 0;
  font-size: 0.95rem;
}

/* Coral with an ink-deep label (7.83), same pairing as the site's buttons —
   white on coral would only be 2.27. */
.bb-step-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: var(--interactive-default);
  color: var(--interactive-label);
  font-weight: 700;
}

/* --- Join CTA ------------------------------------------------------------ */
.busy-bees .bb-cta-section {
  padding: 36px 0 64px;
}

.bb-cta {
  position: relative;
  overflow: hidden;
  background-color: var(--bb-olive);
  border-radius: 28px;
  padding: 44px 28px;
  text-align: center;
  color: var(--bb-olive-muted);
}

/* The two soft glows from the design: warm top-right, green bottom-left. */
.bb-cta::before,
.bb-cta::after {
  content: "";
  position: absolute;
  width: 260px;
  height: 260px;
  border-radius: 50%;
  pointer-events: none;
}

.bb-cta::before {
  top: -90px;
  right: -90px;
  background: radial-gradient(circle, rgba(238, 150, 117, 0.2), transparent 70%);
}

.bb-cta::after {
  bottom: -90px;
  left: -90px;
  background: radial-gradient(circle, rgba(204, 220, 158, 0.22), transparent 70%);
}

.bb-cta > * {
  position: relative;
  z-index: 1;
}

.bb-cta h2 {
  color: var(--bb-olive-text);
  font-size: 2rem;
  margin-bottom: 12px;
}

.bb-cta p {
  max-width: 460px;
  margin: 0 auto;
}

.bb-cta-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin: 24px 0 18px;
}

.bb-cta-actions .btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.bb-btn-ghost,
.bb-btn-ghost:visited {
  display: inline-block;
  color: var(--bb-olive-text);
  font-weight: 600;
  padding: 12px 28px;
  border-radius: 999px;
  border: 2px solid var(--bb-olive-muted);
  transition: background-color 0.15s ease;
}

.bb-btn-ghost:hover {
  background-color: rgba(255, 255, 255, 0.1);
  text-decoration: none;
}

.bb-cta-note {
  font-size: 0.9rem;
  overflow-wrap: anywhere;
}

.bb-cta-note a,
.bb-cta-note a:visited {
  color: var(--bb-olive-text);
  text-decoration: underline;
}

.bb-cta :focus-visible {
  outline-color: var(--color-cream);
}

@media (max-width: 780px) {
  .bb-supplies {
    padding: 22px 18px;
  }

  .bb-cta {
    padding: 36px 20px;
  }
}

/* Phones: stack instead of squeezing things side by side. */
@media (max-width: 600px) {
  .bb-supplies .bb-section-heading h2 {
    font-size: 1.6rem;
  }

  /* Icon above centered text; the desktop zig-zag leaves too narrow a text
     column at this width. */
  .bb-supply-row,
  .bb-supply-row:nth-child(even) {
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }

  .bb-supply-list {
    gap: 28px;
  }

  .bb-icon-circle {
    width: 56px;
    height: 56px;
  }

  /* Full-width buttons so labels never wrap. */
  .bb-cta-actions {
    flex-direction: column;
    align-items: center;
  }

  .bb-cta-actions .btn,
  .bb-cta-actions .bb-btn-ghost {
    width: 100%;
    max-width: 300px;
    justify-content: center;
    text-align: center;
    padding-left: 16px;
    padding-right: 16px;
    white-space: nowrap;
  }

  .bb-cta {
    padding: 32px 16px;
  }

  /* Email and Instagram on their own lines, no dangling separator. */
  .bb-cta-note span,
  .bb-cta-note a {
    display: block;
  }

  .bb-cta-sep {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/BusyBees.css"],"names":[],"mappings":"AAAA;gEACgE;AAChE;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,oCAAoC;EACpC,mBAAmB,EAAE,gEAAgE;EACrF,mBAAmB;AACrB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA,8EAA8E;AAC9E,oEAAoE;AACpE,oEAAoE;AACpE;EACE,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,oEAAoE;AACpE;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA,8EAA8E;AAC9E;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,8EAA8E;AAC9E;EACE,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;uCACuC;AACvC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;EAC5C,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,8EAA8E;AAC9E;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,2EAA2E;AAC3E;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,+EAA+E;AACjF;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,4DAA4D;AAC5D;EACE;IACE,iBAAiB;EACnB;;EAEA;4BAC0B;EAC1B;;IAEE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,6CAA6C;EAC7C;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,mEAAmE;EACnE;;IAEE,cAAc;EAChB;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* The header is the shared FeatureHeader component. Contrast: white on olive 7.24, cream on olive\n   5.76, olive on the page 6.28, olive on sunken 5.39. All AA. */\n.busy-bees {\n  --bb-olive: var(--color-olive);\n  --bb-olive-text: var(--color-white);\n  --bb-olive-muted: var(--color-cream);\n  --bb-panel: #e9eed6; /* sunken green lifted toward the page, for the supplies panel */\n  --bb-beige: #f3e9df;\n}\n\n.busy-bees h1,\n.busy-bees h2,\n.busy-bees h3 {\n  color: var(--bb-olive);\n}\n\n.busy-bees section {\n  padding: 28px 0;\n}\n\n/* Content sits in one centered column, as in the design. */\n.bb-narrow {\n  max-width: 760px;\n}\n\n.bb-section-heading {\n  text-align: center;\n  margin-bottom: 24px;\n}\n\n.bb-section-heading h2 {\n  margin-bottom: 6px;\n}\n\n.bb-section-heading p {\n  margin: 0;\n  font-size: 0.95rem;\n}\n\n/* --- We supply everything ------------------------------------------------ */\n/* A centered, roughly square panel rather than a full-width band. */\n/* A centered, roughly square panel rather than a full-width band. */\n.bb-supplies {\n  max-width: 600px;\n  margin: 0 auto;\n  background-color: var(--bb-panel);\n  border-radius: 32px;\n  padding: 44px 40px;\n}\n\n.bb-supplies .bb-section-heading {\n  margin-bottom: 36px;\n}\n\n.bb-supplies .bb-section-heading h2 {\n  font-size: 2rem;\n  margin-bottom: 10px;\n}\n\n.bb-supply-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 32px;\n}\n\n.bb-supply-row {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n/* Every other row mirrors: icon on the right, text right-aligned. */\n.bb-supply-row:nth-child(even) {\n  flex-direction: row-reverse;\n  text-align: right;\n}\n\n.bb-supply-row h3 {\n  font-size: 1.2rem;\n  margin: 0 0 6px;\n}\n\n.bb-supply-row p {\n  margin: 0;\n}\n\n.bb-icon-circle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background-color: var(--surface-raised);\n  color: var(--text-accent);\n  box-shadow: 0 2px 6px rgba(89, 88, 96, 0.14);\n}\n\n/* --- What you'll make ---------------------------------------------------- */\n.bb-chips {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 10px;\n}\n\n.bb-chip {\n  font-size: 0.9rem;\n  font-weight: 600;\n  padding: 6px 16px;\n  border-radius: 999px;\n  border: 1px solid var(--border-subtle);\n}\n\n.bb-chip-green {\n  background-color: var(--bb-panel);\n}\n\n.bb-chip-white {\n  background-color: var(--surface-raised);\n}\n\n.bb-chip-beige {\n  background-color: var(--bb-beige);\n}\n\n/* --- How it works -------------------------------------------------------- */\n.bb-steps {\n  list-style: none;\n  margin: 0 auto;\n  padding: 0;\n  max-width: 480px;\n  display: grid;\n  gap: 20px;\n}\n\n.bb-steps li {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n}\n\n.bb-steps h3 {\n  font-size: 1.05rem;\n  margin: 0 0 2px;\n}\n\n.bb-steps p {\n  margin: 0;\n  font-size: 0.95rem;\n}\n\n/* Coral with an ink-deep label (7.83), same pairing as the site's buttons —\n   white on coral would only be 2.27. */\n.bb-step-number {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background-color: var(--interactive-default);\n  color: var(--interactive-label);\n  font-weight: 700;\n}\n\n/* --- Join CTA ------------------------------------------------------------ */\n.busy-bees .bb-cta-section {\n  padding: 36px 0 64px;\n}\n\n.bb-cta {\n  position: relative;\n  overflow: hidden;\n  background-color: var(--bb-olive);\n  border-radius: 28px;\n  padding: 44px 28px;\n  text-align: center;\n  color: var(--bb-olive-muted);\n}\n\n/* The two soft glows from the design: warm top-right, green bottom-left. */\n.bb-cta::before,\n.bb-cta::after {\n  content: \"\";\n  position: absolute;\n  width: 260px;\n  height: 260px;\n  border-radius: 50%;\n  pointer-events: none;\n}\n\n.bb-cta::before {\n  top: -90px;\n  right: -90px;\n  background: radial-gradient(circle, rgba(238, 150, 117, 0.2), transparent 70%);\n}\n\n.bb-cta::after {\n  bottom: -90px;\n  left: -90px;\n  background: radial-gradient(circle, rgba(204, 220, 158, 0.22), transparent 70%);\n}\n\n.bb-cta > * {\n  position: relative;\n  z-index: 1;\n}\n\n.bb-cta h2 {\n  color: var(--bb-olive-text);\n  font-size: 2rem;\n  margin-bottom: 12px;\n}\n\n.bb-cta p {\n  max-width: 460px;\n  margin: 0 auto;\n}\n\n.bb-cta-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 12px;\n  margin: 24px 0 18px;\n}\n\n.bb-cta-actions .btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.bb-btn-ghost,\n.bb-btn-ghost:visited {\n  display: inline-block;\n  color: var(--bb-olive-text);\n  font-weight: 600;\n  padding: 12px 28px;\n  border-radius: 999px;\n  border: 2px solid var(--bb-olive-muted);\n  transition: background-color 0.15s ease;\n}\n\n.bb-btn-ghost:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  text-decoration: none;\n}\n\n.bb-cta-note {\n  font-size: 0.9rem;\n  overflow-wrap: anywhere;\n}\n\n.bb-cta-note a,\n.bb-cta-note a:visited {\n  color: var(--bb-olive-text);\n  text-decoration: underline;\n}\n\n.bb-cta :focus-visible {\n  outline-color: var(--color-cream);\n}\n\n@media (max-width: 780px) {\n  .bb-supplies {\n    padding: 22px 18px;\n  }\n\n  .bb-cta {\n    padding: 36px 20px;\n  }\n}\n\n/* Phones: stack instead of squeezing things side by side. */\n@media (max-width: 600px) {\n  .bb-supplies .bb-section-heading h2 {\n    font-size: 1.6rem;\n  }\n\n  /* Icon above centered text; the desktop zig-zag leaves too narrow a text\n     column at this width. */\n  .bb-supply-row,\n  .bb-supply-row:nth-child(even) {\n    flex-direction: column;\n    text-align: center;\n    gap: 12px;\n  }\n\n  .bb-supply-list {\n    gap: 28px;\n  }\n\n  .bb-icon-circle {\n    width: 56px;\n    height: 56px;\n  }\n\n  /* Full-width buttons so labels never wrap. */\n  .bb-cta-actions {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .bb-cta-actions .btn,\n  .bb-cta-actions .bb-btn-ghost {\n    width: 100%;\n    max-width: 300px;\n    justify-content: center;\n    text-align: center;\n    padding-left: 16px;\n    padding-right: 16px;\n    white-space: nowrap;\n  }\n\n  .bb-cta {\n    padding: 32px 16px;\n  }\n\n  /* Email and Instagram on their own lines, no dangling separator. */\n  .bb-cta-note span,\n  .bb-cta-note a {\n    display: block;\n  }\n\n  .bb-cta-sep {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
